"use client";
import Detailslist from "@/components/Detailslist/Detailslist";
import { blogs, blogFilter } from "@/utils/data";
import BlogCard from "../components/BlogsCarousel/BlogCard/BlogCard";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs, selectAllBlogs } from "@/slice/blogsSlice";
import { useEffect } from "react";

export default function Blog() {
  const props = {
    heading: "Search accordingly your convenience",
    filterData: blogFilter,
  };

  const dispatch = useDispatch();
  const blog = useSelector(selectAllBlogs);

  const lang = useSelector((state) => state.locale.locale);
  useEffect(() => {
    dispatch(fetchBlogs(lang));
  }, [lang]);

  return (
    <>
      <BreadCrumbs />
      <Detailslist props={props}>
        {blog?.data?.length > 0 &&
          blog?.data.map((blog, i) => <BlogCard key={i} blog={blog} />)}
      </Detailslist>
    </>
  );
}
